import {
  GiftCardAddonOnlineDetails,
  GiftCardAddonOutletDetails,
} from '@ancon/wildcat-types'

export type GiftCardPageQuery = {
  giftCardShareKey?: string
}

export interface GiftCardPurchaseFormData {
  quantity: number
  greetingPhrase: string
  receiverName: string
  receiverEmail: string
  receiverPhoneNumber: string
  sendViaSms: boolean
  buyerEmail: string
  buyerName: string
  customAmount: number | null
  predefinedAmount: number | null
}

export type GiftCardPurchasePageParams = {
  outletSlug: string
}

export type GiftCardPurchasePaymentPageParams = {
  outletSlug: string
  checkoutId: string
}

export type GiftCardCheckoutPaymentParams = {
  outletId: string
  checkoutId: string
}

export interface GiftCardsReducerState {
  // Gift card addon
  giftCardAddon: GiftCardAddonOnlineDetails | null
  giftCardAddonOutlet: GiftCardAddonOutletDetails | null
  /** Gift card addon fetch completed */
  giftCardAddonInitialized: boolean

  // Gift card external purchase checkout
  checkoutPaymentParams: GiftCardCheckoutPaymentParams | null
  checkoutCancelModalVisible: boolean
}

export enum GiftCardPurchaseMode {
  Internal = 'internal',
  External = 'external',
}

export type GiftCardPurchaseCartSummary = {
  subtotalExclTaxAmount: string | null
  subtotalInclTaxAmount: string | null
  discountAmount: string | null
  taxAmount: string | null
  totalAmount: string
}

export type GiftCardCheckoutResultPageQuery = {
  outletId?: string
  checkoutId?: string
  /* Unknown query parameters coming from adyen side */
} & Record<string, unknown>
